import { cloneDeep } from "lodash";
import { getType } from "./get-type";

export const getValueInObjectByPath = function (
  srcObj: Record<string, any>,
  path: string,
) {
  if (!srcObj) return srcObj;
  const pathArr: Array<string> = path.split("/");
  let pointer: any = srcObj;
  let key: string | undefined;
  while (pathArr.length > 0) {
    key = pathArr.shift();
    if (!key) throw Error();
    if (
      getType(pointer) === "[object Object]" &&
      Object.keys(pointer).indexOf(key) < 0 &&
      pathArr.length > 0
    )
      throw Error();
    if (getType(pointer) === "[object Array]") {
      // 验证key是否为数字格式
      if (!/^[0-9]\d*$/.test(key)) throw Error();
      if (parseInt(key) > pointer.length || parseInt(key) < 0) throw Error();
    }
    pointer = pointer[key];
  }
  return pointer;
};

/**
 * 根据路径动态生成对象
 * @param path
 * @param value
 * @param base
 */
export const createObjByPath = function (
  path: string,
  value: any,
  base = {},
): any {
  const pathArr: Array<string> = path.trim().split("/");
  const copy = cloneDeep(base);
  const res = copy;
  let pointer: any = copy;
  let key: string;
  while (pathArr.length > 0) {
    key = pathArr.shift();
    if (!key) throw Error("key is not found");
    // 已经是最后一个key， 进行赋值
    if (pathArr.length === 0) pointer[key] = value;
    // 不是最后一个， 需要校验 pointer[key] 是否存在， 不存在则创建
    else if (!pointer[key])
      pointer[key] = /^[0-9]\d*$/.test(pathArr[0]) ? [] : {};
    // 不管是不是最后一个， 如果key是数字， 那么数组的其他项用 {} 替代
    if (/^[0-9]\d*$/.test(key))
      for (let i = 0; i < parseInt(key); i++) {
        if (!pointer[i]) pointer[i] = {};
      }
    pointer = pointer[key];
  }
  return res;
};
